import React, { useEffect, useState } from "react";
import "./sidebar.css";
import amoLogo from "../../assets/image/logo-amospa.svg";
import close from "../../assets/xWhite.svg";
import axios from "axios";
import { NavLink } from "react-router-dom";
import Navigation from "../navbar/Navigation";
import { useSelector, useDispatch } from "react-redux";
import { getActionSucces } from "../../redux/actions/burgerAction";
import { AiFillDashboard } from "react-icons/ai";
import { MdRememberMe } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import { RiGroupFill } from "react-icons/ri";
import { GiVerticalBanner } from "react-icons/gi";
import { GiCoffeeCup } from "react-icons/gi";
import { GiPersonInBed } from "react-icons/gi";
import { FaQuestion } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";
import { TbDiscount } from "react-icons/tb";

function Sidebar() {
  const dispatch = useDispatch();
  const dataBurger = useSelector((state) => state.burgerReducer.data);
  const [closeIcon, setCloseIcon] = useState("openSidebar");
  const [data, setData] = useState(false);

  const userId = window.sessionStorage.getItem("dataLogin");


  const burgerBtn = () => {
    if (dataBurger === "openSidebar") {
      setCloseIcon("openSidebar");
    }
    if (dataBurger === "closeSidebar") {
      setCloseIcon("closeSidebar");
    }
  };

  useEffect(() => {
    burgerBtn();
    getUserById()
  }, [dataBurger]);

  const getUserById = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${userId}` },
    });
    const id = await rest.get("/jwt/token");
    let result = await axios.get(
      `https://mobile.amospa.com/staff/${id.data.data}`
    );
    setData(result.data.data[0]);
  };

  return (
    <div className="wrapper-side">
      <div className={closeIcon}>
        <div className="header-sidebar">
          <div className="close-on">
            <img
              onClick={() => dispatch(getActionSucces("closeSidebar"))}
              className="closeImg"
              src={close}
              alt=""
            />
          </div>
          <img className="logo-amo" src={amoLogo} alt="logo-amo" />
        </div>
        <div className="main-sidebar">
          <ul>
            <NavLink
              to={"/homepage/"}
              className={({ isActive }) =>
                isActive ? "active-sidebar" : "non-active-sidebar"
              }
            >
              <li>
                <AiFillDashboard color="#FFD700" fontSize="25px" />
                <span className="title ms-2">Home</span>
              </li>
            </NavLink>
            <NavLink
              to={"/homepage/members/"}
              className={({ isActive }) =>
                isActive ? "active-sidebar" : "non-active-sidebar"
              }
            >
              <li>
                <HiUserGroup color="#FFD700" fontSize="25px" />
                <span className="title ms-2">Member</span>
              </li>
            </NavLink>
            <NavLink
              to={"/homepage/users-mobile/"}
              className={({ isActive }) =>
                isActive ? "active-sidebar" : "non-active-sidebar"
              }
            >
              <li>
                <MdRememberMe color="#FFD700" fontSize="25px" />
                <span className="title ms-2">Users Mobile Apps</span>
              </li>
            </NavLink>
            {
              data?.email == 'user@amospa.com' ? null : 
              <div>

                <NavLink
                  to={"/homepage/staff/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <RiGroupFill color="#FFD700" fontSize="22px" />
                    <span className="title ms-2">Staff ID</span>
                  </li>
                </NavLink>
                <NavLink
                  to={"/homepage/setting/banner/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <GiVerticalBanner color="#FFD700" fontSize="25px" />
                    <span className="title ms-2 mt-0">Banner</span>
                  </li>
                </NavLink>
                <NavLink
                  to={"/homepage/promo/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <TbDiscount color="#FFD700" fontSize="27px" />
                    <span className="title ms-2 mb-1">Promo</span>
                  </li>
                </NavLink>
                <NavLink
                  to={"/homepage/cafe/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <GiCoffeeCup color="#FFD700" fontSize="25px" />
                    <span className="title ms-2">Cafe</span>
                  </li>
                </NavLink>
                <NavLink
                  to={"/homepage/spa/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <GiPersonInBed color="#FFD700" fontSize="25px" />
                    <span className="title ms-2">Spa</span>
                  </li>
                </NavLink>
                <NavLink
                  to={"/homepage/setting/faq/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <FaQuestion color="#FFD700" fontSize="21px" />
                    <span className="title ms-2">FAQ</span>
                  </li>
                </NavLink>
                <NavLink
                  to={"/homepage/setting/role/"}
                  className={({ isActive }) =>
                    isActive ? "active-sidebar" : "non-active-sidebar"
                  }
                >
                  <li>
                    <AiFillSetting color="#FFD700" fontSize="23px" />
                    <span className="title ms-2 mt-0">Role</span>
                  </li>
                </NavLink>
              </div>
            }
          </ul>
        </div>
      </div>
      <div className="right-sidebar">
        <Navigation />
      </div>
    </div>
  );
}

export default Sidebar;
